module.exports = __webpack_public_path__ + "img/check1.14f42d62.svg";